import Guid from "@/app/utils/guid"

export default class StoreProduct {
  public productId = Guid.empty()
  public storeId = Guid.empty()
  public minStock = 0
  public minOrderQuantity = 0
}